module.exports = __webpack_public_path__ + "static/media/OM.92774a37.png";